/**
 * 米币充值金额校验
 * @author cuiliangliang
 */

export default {
  integer: /^(10000|[1-9]\d{0,3})$/,
  decimal: /^(10000|[1-9]\d{0,3}|[1-9]\d{0,3}\.[0-9][1-9]|[1-9]\d{0,3}\.[1-9]|0\.[1-9]|0\.[0-9][1-9])$/
}
